import { Checkbox, Label } from "@components";
import style from "@styles/pages/oraculo/oraculo.module.scss";

import { If } from "@components/control-statements";
import { Numbers } from "@utils/Numbers";
import classNames from "classnames/bind";
const css = classNames.bind(style);

const PERFIL = {
  CAMPEOES: "CAMPEOES",
  HIBERNANDO: "HIBERNANDO",
  PROMISSORES: "PROMISSORES",
  LEAL: "LEAL",
  EM_RISCO: "EM_RISCO",
  REQUER_ATENCAO: "REQUER_ATENCAO",
  DESLIGANDO: "DESLIGANDO",
  ABANDONADOS: "ABANDONADOS",
  INDEFINIDO: "UNDEFINED",
};

const getPercentageValues = (rfv_profile) => {
  console.log({ rfv_profile });

  const { UNDEFINED, ...props_to_totalize } = rfv_profile || {};
  const total = Object.values(props_to_totalize).reduce(
    (t, p) => t + Number(p),
    0
  );

  const get_profile_value = (alias) => rfv_profile[PERFIL[alias]] || 0;
  const get_percentage = (alias) => (get_profile_value(alias) / (total || 1));

  const rfv = {
    CAMPEOES: {
      percent: get_percentage(PERFIL.CAMPEOES),
      quantity: get_profile_value(PERFIL.CAMPEOES),
    },
    HIBERNANDO: {
      percent: get_percentage(PERFIL.HIBERNANDO),
      quantity: get_profile_value(PERFIL.HIBERNANDO),
    },
    PROMISSORES: {
      percent: get_percentage(PERFIL.PROMISSORES),
      quantity: get_profile_value(PERFIL.PROMISSORES),
    },
    LEAL: {
      percent: get_percentage(PERFIL.LEAL),
      quantity: get_profile_value(PERFIL.LEAL),
    },
    EM_RISCO: {
      percent: get_percentage(PERFIL.EM_RISCO),
      quantity: get_profile_value(PERFIL.EM_RISCO),
    },
    REQUER_ATENCAO: {
      percent: get_percentage(PERFIL.REQUER_ATENCAO),
      quantity: get_profile_value(PERFIL.REQUER_ATENCAO),
    },
    ABANDONADOS: {
      percent: get_percentage(PERFIL.ABANDONADOS),
      quantity: get_profile_value(PERFIL.ABANDONADOS),
    },
    DESLIGANDO: {
      percent: get_percentage(PERFIL.DESLIGANDO),
      quantity: get_profile_value(PERFIL.DESLIGANDO),
    },
    INDEFINIDO: {
      percent: undefined,
      quantity: rfv_profile.UNDEFINED,
    },
  };

  return rfv;
};

export default ({ onSelectFilters, rfv_profile = {}, filters }) => {
  const RFV = getPercentageValues(rfv_profile);
  console.log({ RFV });

  return (
    <>
      <Label>Relação de perfis de performance</Label>
      <div className={css({ fourGrid: true, profiles: true })}>
        <Tag
          alias={PERFIL.CAMPEOES}
          label={"Campeões"}
          tooltip={
            "Compraram recentemente, e tem muita frequência e/ou gastam muito."
          }
          percentage={RFV.CAMPEOES.percent}
          quantity={RFV.CAMPEOES.quantity}
          selected={filters.includes(PERFIL.CAMPEOES)}
          onSelectFilters={onSelectFilters}
        />
        <Tag
          alias={PERFIL.PROMISSORES}
          label={"Promissor"}
          tooltip={
            "Compraram recentemente, e tem baixa ou média frequência e/ou baixo ou médio valor"
          }
          percentage={RFV.PROMISSORES.percent}
          quantity={RFV.PROMISSORES.quantity}
          selected={filters.includes(PERFIL.PROMISSORES)}
          onSelectFilters={onSelectFilters}
        />
        {/* <Tag
					alias={PERFIL.PROMISSORES}
					label={"Promissor"}
					tooltip={"Compraram recentemente, e tem baixa ou média frequência e/ou baixo ou médio valor"}
					percentage={RFV.PROMISSORES.percent}
					quantity={RFV.PROMISSORES.quantity}
					selected={filters.includes(PERFIL.PROMISSORES)}
					onSelectFilters={onSelectFilters}
				/> */}
        <Tag
          alias={PERFIL.REQUER_ATENCAO}
          label={"Requer atenção"}
          tooltip={
            "Compraram há algum tempo, mas tem muita frequência e/ou gastam muito."
          }
          percentage={RFV.REQUER_ATENCAO.percent}
          quantity={RFV.REQUER_ATENCAO.quantity}
          selected={filters.includes(PERFIL.REQUER_ATENCAO)}
          onSelectFilters={onSelectFilters}
        />
        <Tag
          alias={PERFIL.EM_RISCO}
          label={"Em risco"}
          tooltip={
            "Compraram há algum tempo, e tem frequência média com valor médio ou ruim."
          }
          percentage={RFV.EM_RISCO.percent}
          quantity={RFV.EM_RISCO.quantity}
          selected={filters.includes(PERFIL.EM_RISCO)}
          onSelectFilters={onSelectFilters}
        />
        <Tag
          alias={PERFIL.DESLIGANDO}
          label={"Desligando"}
          tooltip={
            "Compraram há algum tempo, e tem frequência média e/ou ruim, com valor médio e/ou ruim."
          }
          percentage={RFV.DESLIGANDO.percent}
          quantity={RFV.DESLIGANDO.quantity}
          selected={filters.includes(PERFIL.DESLIGANDO)}
          onSelectFilters={onSelectFilters}
        />
        <Tag
          alias={PERFIL.HIBERNANDO}
          label={"Hibernando"}
          tooltip={
            "Compraram há muito tempo, porém possuem boa ou média frequência, com bom ou médio valor."
          }
          percentage={RFV.HIBERNANDO.percent}
          quantity={RFV.HIBERNANDO.quantity}
          selected={filters.includes(PERFIL.HIBERNANDO)}
          onSelectFilters={onSelectFilters}
        />
        <Tag
          alias={PERFIL.ABANDONADOS}
          label={"Abandonados"}
          tooltip={
            "Compraram há muito tempo, e tem frequência média e/ou ruim, com valor médio e/ou ruim."
          }
          percentage={RFV.ABANDONADOS.percent}
          quantity={RFV.ABANDONADOS.quantity}
          selected={filters.includes(PERFIL.ABANDONADOS)}
          onSelectFilters={onSelectFilters}
        />
        <Tag
          alias={PERFIL.INDEFINIDO}
          label={"Indefinidos"}
          tooltip={"Não possuem perfil de performance."}
          percentage={RFV.INDEFINIDO.percent}
          quantity={RFV.INDEFINIDO.quantity}
          selected={filters.includes(PERFIL.INDEFINIDO)}
          onSelectFilters={onSelectFilters}
        />
      </div>
    </>
  );
};

const Tag = ({
  alias,
  label,
  percentage,
  quantity,
  tooltip,
  selected,
  onSelectFilters,
}) => {
  const _percentage = Numbers.percent(percentage, 2);
  const _quantity = Numbers.formatInt(quantity);
  return (
    <div
      className={css({ item: true, selected: selected })}
      onClick={() => onSelectFilters(alias)}
    >
      <div className="d-flex flex-column">
        <div className="d-flex align-center">
          <p className={style.name}>{label}</p>
          <div className={style.tooltip} data-tooltip={tooltip}>
            <i className="far fa-info-circle" />
          </div>
        </div>
        <div className="d-flex align-center">
          <If cond={percentage !== undefined}>
            <span className={style.percentage}>{_percentage}</span>
          </If>
          <span className={style.quantity}>
            <If cond={percentage !== undefined}>
              <span className={style.dot} />
            </If>
            {_quantity}
          </span>
        </div>
      </div>

      <div className={style.iconContainer}>
        <div className={style.icon}>
          <i className="far fa-medal" />
          <div className={style.checkbox}>
            <Checkbox value={alias} checked={selected} />
          </div>
        </div>
      </div>
    </div>
  );
};
